module.exports = __webpack_public_path__ + "static/media/2.8aaa0192.png";